module.exports = __webpack_public_path__ + "img/carousel-1.f54328a6.png";